import type { ILeiProfile } from '@core/models/app.model';
import { isHieroglyphs } from '@helpers/isHieroglyphs';

export const getCompanyNameFromLei = (leiProfile: ILeiProfile): string => {
  const profileName = leiProfile?.attributes?.entity.legalName.name;
  const otherName = leiProfile?.attributes?.entity.otherNames.find(
    (item) => item.language === 'en'
  )?.name;
  const transliteratedOtherName = leiProfile?.attributes?.entity.transliteratedOtherNames.find(
    (item) => item.language === 'en'
  )?.name;

  if (!otherName && !transliteratedOtherName) {
    return profileName;
  }

  if (isHieroglyphs(profileName)) {
    const transliteratedName = transliteratedOtherName || otherName || profileName;

    return `${transliteratedName} (${profileName})`;
  }

  return profileName;
};
